import { View } from 'components/View'
import React from 'react'
import TextBodySmall from 'components/TextBodySmall/index.js'

/**
 * @param label
 * @param size
 * @param rest
 * @returns {Element}
 * @constructor
 */
export default function AvatarText ({
  label,
  size,
  ...rest
}) {
  return (
    <View
      w={`${size}px`}
      h={`${size}px`}
      bdr='big'
      ac
      jc
      {...rest}
    >
      <TextBodySmall>{label}</TextBodySmall>
    </View>
  )
}
